import utils from "../../../utils/utils.js";

export default {
    async fetchFeedList(context, payload) {
        const data = {
            QueueId: payload.queueId,
            Page: payload.page,
            StartDate: payload.startDate,
            EndDate: payload.endDate,
            Sort: payload.sort
        };

        // isBackgroundRefresh yalnızca yükleme ekranını bastırmak içindir, istek gövdesine eklenmez
        const skipLoading = payload.isBackgroundRefresh === true;

        const response = await utils.utility.fetch("api/editor/lockfeeds", "PUT", null, data, skipLoading);

        context.commit("setFeedList", response.data);
    },
    async postFeedSentiment(context, payload) {             
        await utils.utility.fetch("api/Editor/ChangeSentiment", "PUT", null, { feedId: payload.feedId, sentimentId: payload.sentimentId });

        context.commit("setSentiment", payload);
    },
    async putFeedFinalizeStatus(context, payload) {        
        const response = await utils.utility.fetch("api/editor/finalizefeed", "PUT", null, { feedIds: payload.feedsToBeFinalize, queueId: payload.queueId, page: payload.page, sort: payload.sort, startDate: payload.startDate, endDate: payload.endDate });
        
        context.commit("putFeedFinalizeStatus", { ...payload, newAssignedFeeds: response.data });
    },
    async putFeedMarkedToBeHashedStatus(context, payload) {                    
        const response = await utils.utility.fetch("api/editor/maskfeedtitle", "PUT", null, payload);
        
        context.commit("putFeedMarkedToBeHashedStatus", response.data);
    },
    async putFeedUnmaskStatus(context, payload) {
        const response = await utils.utility.fetch("api/editor/unmaskfeedtitle", "PUT", null, payload);

        context.commit("putFeedUnmaskStatus", response.data);
    },
    async putFeedRelativeStatus(context, payload) {
        await utils.utility.fetch("api/Editor/MarkFeedAsRelative","PUT",null,{"feedids":payload.feedsToBeRelative, "isrelative":payload.isrelative});
        
        context.commit("putFeedRelativeStatus", payload);
    },
    async putFeedSpamStatus(context, payload) {
        await utils.utility.fetch("api/Editor/MarkFeedAsSpam","PUT",null,{ "feedids":payload.feedsToBeSpam, "isspam":payload.isSpam});
        
        context.commit("putFeedSpamStatus", payload);
    },
    async fetchModerationReasons(context) {
        const responseData = await utils.utility.fetch("api/Editor/GetModerationReasons","GET",null,null);
        
        context.commit("setModerationReasons", responseData.data);
    },
    async deleteFeed(context, payload) {        
        await utils.utility.fetch("api/Editor/DeleteFeed","PUT",null,{"feedids":payload.feedIds, "reasonId":payload.reasonId});
        
        context.commit("deleteFeed", payload);
    },
    async hideFeed(context, payload) {
        await utils.utility.fetch("api/Editor/HideFeed","PUT",null,{"feedids":payload.feedIds, "reasonId":payload.reasonId, "isHidden":true});
        
        context.commit("hideFeed", payload);
    },
    async showFeed(context, payload) {
        await utils.utility.fetch("api/Editor/HideFeed","PUT",null,{"feedids":payload.feedIds, "reasonId":0, "isHidden":false});
        
        context.commit("showFeed", payload)
    },
    async likeFeed(context, payload) {
        await utils.utility.fetch("api/Editor/LikeFeed","PUT",null,{"feedids":payload.feedIds, "accountId":payload.accountId, "isLike":payload.isLike});

        context.commit("likeFeed", payload);
    },
    async reFeed(_,payload){        
        await utils.utility.fetch("api/Editor/RePublishPost","POST",null,{"feedids":payload.feedIds, "accountId":payload.accountId, "isRefeed":payload.isRefeed});        
    },    
    async fetchCommentHistory(context, payload) {        
        const responseData = await utils.utility.fetch(`api/Editor/GetFeedComments?feedId=${payload.feedId}`,"GET",null,null);     
        
        context.commit("setCommentHistory", responseData.data);
    },
    async fetchRegisteredSocialAccounts(context, payload) {        
        const responseData = await utils.utility.fetch(`api/Editor/GetAnswerAccounts?feedId=${payload.feedId}`,"GET",null,null);       
        
        context.commit("setRegisteredSocialAccounts", responseData.data);
    },
    async fetchReplyDrafts(context) {
        const responseData = await utils.utility.fetch("api/Editor/GetAnswerTemplates","GET",null,null);

        context.commit("setReplyDrafts", responseData.data);
    },
    async fetchAttachments(context) {
        const responseData = await utils.utility.fetch("api/Editor/GetAnswerAttachments","GET",null,null);

        context.commit("setAttachments", responseData.data);
    },
    async fetchFeederHistory(context, payload) {
        const responseData = await utils.utility.fetch(`api/editor/getfeederarchive?feedId=${payload.feedId}&isNote=${payload.isNote}&page=${payload.page}`, "GET", null, null, true);
        
        context.commit("setFeederHistory", responseData.data);
    },
    async clearFeederHistory(context){
        context.commit("setEmptyFeederHistory");
    },
    async fetchWorkspaceTags(context){
        const responseData = await utils.utility.fetch("api/Editor/GetWorkspaceTags", "GET", null, null);

        context.commit("setWorkspaceTags", responseData.data);
    },
    async tagFeed(_, payload){
        await utils.utility.fetch("api/Editor/TagFeed", "PUT", null, { "feedids": payload.feedIds, "tagId": payload.tagId });
    },
    async feederConfirmation(context,payload){
        await utils.utility.fetch("api/Editor/FeederConfirmation", "PUT", null, { "feedIds": payload.feedIds, "origin": payload.origin });
        
        context.commit("setFeederConfirmation",payload);
    },
    async deleteAnswer(context,payload){
        await utils.utility.fetch("api/Editor/DeleteAnswer","PUT",null,{"answerId":payload.answerId});

        context.commit("setDeletedHistory", payload);
    },
    async fetchFoxTaskItems(context,payload) {
        const responseData = await utils.utility.fetch(`api/Editor/GetFoxTaskItems?feedId=${payload.feedId}`,"GET",null,null);

        context.commit("setFoxTaskItems", responseData.data);
    }, 
    async updateFoxData(_, payload) {
        await utils.utility.fetch("api/Editor/PostFoxTask","POST",null,payload);        
    },
    async postNote(_,payload){        
        await utils.utility.fetch("api/Editor/PostNote","POST",null,payload);
    },
    async postReply(context,payload) {        
        const responseData = await utils.utility.fetch("api/editor/postReply", "POST", null, payload);
        
        context.commit("setCheckAnswerRules", responseData.data);
    },
    async futureReply(_, payload) {
        await utils.utility.fetch("api/Editor/FutureReply","POST",null,payload);
    },
    async fetchFutureReply(_, payload) {
        const responseData = await utils.utility.fetch(`api/Editor/GetFutureReply?feedId=${payload.feedId}`,"GET",null,null);

        return responseData.data ?? responseData;
    },
    async cancelFutureReply(_, payload) {
        const responseData = await utils.utility.fetch("api/Editor/CancelFutureReply", "PUT", null, payload);

        return responseData.data ?? responseData;
    },
    async fetchFoxHistory(context, payload) {
        const responseData =await utils.utility.fetch(`api/Editor/GetFoxTaskHistory?feedId=${payload.feedId}`,"GET",null,null);
        
        context.commit("setFoxHistory", responseData.data);
    },
    async fetchEmojis(context) {
        const response = await utils.utility.fetch("api/Editor/GetEmojis", "GET", null, null, true);
        
        context.commit("setEmojis", response.data);
    },
    async fetchWorkspaceEmojiIsEnabled(context) {
        const response = await utils.utility.fetch("api/Workspace/GetWorkspaceEmojiIsEnabled", "GET", null, null, true);
        
        context.commit("setEmojisIsEnabled", response.data);
    },
    async fetchMisspells(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getspellcheck?text=${payload.text}&feedlink=${payload.feedLink}&sourceid=${payload.sourceId}&replieraccount=${payload.replierAccount}`, "GET", null, null, true);
        
        context.commit("setMisspells", response.data);
    },
    putSuggestionList(context, payload) {
        context.commit("putSuggestionList", payload);
    },
    async fetchAnswerAuditIsEnabled(context) {
        try {
            const response = await utils.utility.fetch("api/Editor/GetAnswerAuditIsEnabled", "GET", null, null, true);

            context.commit("setAnswerAuditEnabled", !!response.data);
        } catch {
            context.commit("setAnswerAuditEnabled", false);
        }
    },
    async checkAnswerText(context, payload) {
        const body = { feedId: payload.feedId, text: payload.text, replierAccount: payload.replierAccount };

        try {
            const response = await utils.utility.fetch("api/Editor/CheckAnswerText", "POST", null, body, true);

            context.commit("setAnswerAudit", { ...response.data, violations: response.data.violations || [], text: payload.text });
        } catch {
            // Denetim servisine ulaşılamazsa kural uygulanmaz, cevap denetimsiz gönderilebilir
            context.commit("setAnswerAudit", { enabled: true, serviceAvailable: false, canSend: true, violations: [], text: payload.text });
        }
    },
    clearAnswerAudit(context) {
        context.commit("setAnswerAudit", null);
    },
    async fetchCepDefition(context) {
        // Tanım workspace'e bağlı ve tüm kartlar için aynı; workspace başına bir kez çekilir.
        const workspaceId = context.rootGetters.workspaceId;
        if (context.state.cepDefinitionWorkspaceId === workspaceId) return;

        const response = await utils.utility.fetch("api/Editor/GetCepDefinition", "GET", null, null, true);

        context.commit("setCepDefinition", { workspaceId, definition: response.data });
    },
    async fetchFeedAnswer(context,payload) {
        const response = await utils.utility.fetch(`api/Editor/GetFeedAnswer?answerId=${payload.answerId}`, "GET", null, null);

        context.commit("setFeedAnswer", response.data);
    },
    async setFeedAnswerAsSended(_,payload) {
        await utils.utility.fetch(`api/Editor/SetAnswerAsSended`, "PUT", null,{answerId:payload.answerId});        
    },
    async fetchFeedAnswerCount(context,payload){
        const body = {
            feedId: +payload.feedId,
            isMarkSent: payload.isMarkSent,
            isWriteLog: payload.isWriteLog,
            ruleName : payload.ruleName
        }

        var response = await utils.utility.fetch("api/Editor/CheckAnswerCount", "POST", null, body);

        if (response.data) context.commit("setCheckAnswerCount", response.data);
    },
    async fetchCheckAnswerCountCopyTable(context,payload){
        const body = {
            feedId: payload.feedId,
            sourceId: payload.sourceId,
            isWriteLog: payload.isWriteLog,
            relatedTopics : payload.relatedTopics
        }

        var response = await utils.utility.fetch("api/Editor/CheckAnswerCountCopyTable", "POST", null, body);

        if (response.data) context.commit("setCheckAnswerCountCopyTable", response.data);
    },
    async fetchFeedAnswers(context, payload) {
        const response = await utils.utility.fetch(`api/editor/GetFeedAnswers?feedId=${payload.feedId}`, "GET", null, null);
    
        context.commit("setFeedAnswers",response.data);
    },
    async fetchDynamicsCountry(context) {
        let lang="tr";

        const response = await utils.utility.fetch(`api/Editor/GetDynamicsCountry?lang=${lang}`,"GET",null,null,true);

        context.commit("setDynamicsCountry", response.data);
    },
    async fetchDynamicsRelatedFeeds(context, payload) {
        const response = await utils.utility.fetch(`api/Editor/GetDynamicsRelatedFeeds?docid=${payload.docid}`,"GET",null,null,true);

        context.commit("setDynamicsRelatedFeeds", response.data);
    },
    async fetchDynamicsMainFeed(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getdynamicsmainfeed?docid=${payload.docid}`, "GET", null, null, true);

        context.commit("setDynamicsMainFeed", response.data);
    },
    async fetchDynamicsIdSet(_, payload) {
        await utils.utility.fetch("api/editor/setdynamicsid", "POST", null, payload);
    },
    async fetchDynamicsIdSetUpdate(_, payload) {
        await utils.utility.fetch("api/editor/setdynamicsidupdate", "POST", null, payload);
    },
    clearMisspellList(context) {
        context.commit("deleteMisspellList");
    },
    async fetchTotalHistoryCount(context, payload) {
        const response = await utils.utility.fetch(`api/editor/gettotalhistorycount?feedId=${payload}`, "GET", null, null, true);

        context.commit("setTotalHistoryCount", response.data);
    },
    async fetchReplySuggestions(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getreplysuggestions?replytask=${payload.replyText}&feedid=${payload.feedId}`, "GET", null, null);

        context.commit("setReplySuggestions", response.data);
    },
    postReplySuggestion(context, payload) {
        const suggestions = context.rootGetters["operationFeed/replySuggestions"];

        const selectedSuggestion = suggestions.find(x => x.id == payload).suggestion;

        context.commit("setSelectedSuggestion", selectedSuggestion);
    },
    async putReplySuggestionStatus(_, payload) {
        await utils.utility.fetch("api/editor/putreplysuggestionstatus", "PUT", null, { id: payload }, true);
    },
    async fetchFeedNotes(context, payload) {
        const response = await utils.utility.fetch(`api/editor/getnotes?id=${payload.id}`, "GET", null, null);

        context.commit("setFeedNotes", response.data);
    },
    async deleteFeedNote(context, payload) {
        await utils.utility.fetch("api/editor/deletenote", "PUT", null, payload);

        context.commit("deleteFeedNote", payload);
    }
}